// =============================================================
// Toast.js — Bildirim sistemi
// =============================================================
import React, { useState, useCallback, useRef } from "react";

let _addToast;

export function useToast() {
  return { toast: _addToast || (() => {}) };
}

export default function ToastContainer() {
  const [toasts, setToasts] = useState([]);
  const counter = useRef(0);

  _addToast = useCallback((message, type = "default", duration = 2800) => {
    const id = ++counter.current;
    setToasts((t) => [...t, { id, message, type }]);
    setTimeout(() => setToasts((t) => t.filter((x) => x.id !== id)), duration);
  }, []);

  if (!toasts.length) return null;

  return (
    <div className="toast-container">
      {toasts.map((t) => (
        <div key={t.id} className={`toast ${t.type}`}>
          {t.message}
        </div>
      ))}
    </div>
  );
}
